module.exports = __webpack_public_path__ + "static/media/programmer.c1a95f73.svg";